export default __webpack_public_path__ + "static/media/loading_transparent_HC.700a4e8f.gif";